// ANGULAR
import { RouterOutlet } from '@angular/router';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  imports: [
    RouterOutlet,
  ]
})
export class AppComponent implements OnInit {
  constructor() { }

  ngOnInit(): void { }
}